import { FormEvent, useState } from 'react';
import apiEndpoints from '@repo/api-endpoints';
import { NewsletterSubscribeFormData } from './contracts';
import { Link } from 'react-router';

export type NewsletterSubscribeProps = NewsletterSubscribeFormData;

function NewsletterSubscribe({ title }: NewsletterSubscribeProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-expect-error TODO: Implement proper type
    const email = e.currentTarget.elements.email.value;

    try {
      await fetch(apiEndpoints.endpoints.newsletterSubscribe, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // @ts-ignore fix vite import type
          'x-tenant-id': import.meta.env.VITE_TENANT_ID,
        },
        body: JSON.stringify({ email }),
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
    }
  };

  if (isSubmitted) {
    return (
      <div className={'newsletter-form--success'}>
        <p>
          You have received an email with confirmation for opting in to our newsletter.
          <br />
          Please check your inbox and click on the link in order to confirm your subscription.
        </p>
      </div>
    );
  }

  if (isMobile) {
    return (
      <form className={'newsletter-form'} onSubmit={onSubmit}>
        {title && <h2 className={'newsletter-form__title'}>{title}</h2>}
        <input id="email" type="email" name={'email'} placeholder="Enter email address" required autoComplete="email" />

        <div className={'newsletter-form__terms-wrapper'}>
          <input type={'checkbox'} id={'terms'} required />
          <label className={'newsletter-form__terms-label'} htmlFor={'terms'}>
            I agree to the{' '}
            <Link to="/data-protection" target="_blank">
              terms and conditions
            </Link>{' '}
            and{' '}
            <Link to="/privacy-policy" target="_blank">
              privacy policy
            </Link>
          </label>
        </div>

        <button type="submit">Subscribe</button>
      </form>
    );
  }

  return (
    <form className={'newsletter-form'} onSubmit={onSubmit}>
      {title && <h2 className={'newsletter-form__title'}>{title}</h2>}

      <div className={'newsletter-form__input-wrapper'}>
        <input id="email" type="email" name={'email'} placeholder="Enter email address" required autoComplete="email" />
        <button type="submit">Subscribe</button>
      </div>

      <div className={'newsletter-form__terms-wrapper'}>
        <input type={'checkbox'} name="terms123" id={'terms123'} required />
        <label className={'newsletter-form__terms-label'} htmlFor={'terms123'}>
          I agree to the{' '}
          <Link to="/data-protection" target="_blank">
            terms and conditions
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" target="_blank">
            privacy policy
          </Link>
        </label>
      </div>
    </form>
  );
}

export default NewsletterSubscribe;
